import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query magnetTimeouts {
  magnetTimeouts {
    id
    magnetTimeout
    team {
      id
      name
    }
    channel {
      id
      name
    }
    requestType {
      id
      name
    }    
  }
}`;

async function getMagnets() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.magnetTimeouts);
}

export default getMagnets;
